var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEditProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.2517354,12.3366842 L22.3437593,15.4438218 L14.5169931,23.3089181 L11.4267223,20.2017805 L19.2517354,12.3366842 Z M24.6900073,11.5873138 L23.3110836,10.2016371 C22.7781773,9.66612095 21.9128474,9.66612095 21.3781305,10.2016371 L20.0572595,11.5289768 L23.1492833,14.6361433 L24.6900073,13.0878739 C25.1033309,12.6724973 25.1033309,12.0026616 24.6900073,11.5873138 Z M9.80860437,24.5691125 C9.7523335,24.8236004 9.98098061,25.0516345 10.234257,24.9897453 L13.6797987,24.1502414 L10.5895279,21.0431038 L9.80860437,24.5691125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Upgrade-Unverify",
    transform: "translate(-75.000000, -39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icEditProfile",
    transform: "translate(75.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    fill: "#7CBC45",
    fillRule: "nonzero",
    cx: 17,
    cy: 17,
    r: 15.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditProfile);
export default __webpack_public_path__ + "static/media/icEditProfile.5486e1c3325d64e97bf5cdefba019556.svg";
export { ForwardRef as ReactComponent };